import { FC } from 'react';

import { BadgeGroupCell } from '@/design-system';

import { getAdminUserStatusBadges } from '../data';
import { UserTabTableRow } from './user-tab-table.utils';

type Props = Pick<UserTabTableRow, 'statuses'>;

export const UserTabTableStatus: FC<Props> = ({ statuses }) => {
  const badges = getAdminUserStatusBadges(statuses);

  return <BadgeGroupCell badges={badges} />;
};
